const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZibitLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 36,
    viewBox: "0 0 123.38477 35.594528",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zibitGrad",
    x1: 112.2532,
    y1: 60.990906,
    x2: 151.44827,
    y2: 96.818382,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-255.12448,4.5640621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15427928,
    style: {
      stopColor: "#f79a53",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f52442",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81644142,
    style: {
      stopColor: "#633fcc",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.28754,-65.639441)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#zibitGrad)",
      strokeWidth: 0.264583
    },
    d: "m -130.67169,101.22698 c -1.06643,-0.0881 -2.04115,-0.37091 -2.99007,-0.83726 -2.72451,-1.33897 -5.92238,-4.80203 -7.62529,-8.25764 -0.45461,-0.76735 -0.73144,-1.59115 -1.00775,-2.43154 -0.41947,-1.27577 -0.74372,-2.76432 -0.89738,-4.1196 -0.10401,-0.60245 -0.2016,-3.41852 0.16054,-5.42919 0.35058,-1.9465 0.82764,-3.45154 1.643,-5.18337 0.23505,-0.49924 0.48052,-0.86911 0.48808,-0.87018 0.0447,0.0641 0.88663,1.46862 0.931,1.54546 l -0.2098,0.47438 c -0.61993,1.40178 -1.12092,3.20501 -1.35084,4.86212 -0.166,0.7843 -0.13256,1.57681 -0.13256,2.37289 0,5.5519 2.19611,10.27544 6.51934,14.0222 1.78547,1.54739 2.89188,2.08147 4.65331,2.24619 l 0.80769,0.0755 16.96758,-0.11423 -0.81144,-1.37895 -0.81144,-1.37895 -15.88975,-0.0262 -0.45739,-0.0335 c -3.21682,-0.23549 -10.12461,-7.41565 -7.5847,-17.37542 h 1.66328 c -1.00377,3.87064 -0.87902,8.82425 2.20809,12.52545 l 0.30766,0.36886 c 0.0479,-0.30731 -0.006,-0.57406 0.39225,-1.56714 0.10939,-0.27245 3.60144,-6.31925 6.09475,-10.64983 1.11263,-1.93252 2.02397,-3.54225 2.0252,-3.57717 -3.67958,-0.0999 -7.36507,-0.0636 -11.04676,-0.0637 l -0.24854,-0.44441 c -0.39239,-0.70162 -5.80421,-10.037843 -5.86473,-10.195577 l -0.0432,-0.112509 0.91923,0.0033 0.91922,0.0033 c 1.49313,2.600759 2.98138,5.204333 4.48015,7.801846 l 0.76919,1.33149 16.82025,0.0464 c 0.53291,0.002 0.73848,0.66063 0.49249,1.10067 -2.55763,4.87803 -8.04191,14.45662 -8.04191,14.45662 l 2.93246,0.0214 c 0.13697,-0.23724 8.63486,-14.95601 8.86209,-15.3496 0.87088,-2.105041 -0.65851,-3.361733 -2.19547,-3.361733 -0.46894,0 -16.86531,-0.04622 -16.86531,-0.04622 -1.10252,-2.017556 -2.42422,-3.921418 -3.46732,-5.970119 6.10776,0 18.00323,-0.107524 21.27455,-0.059 6.306,0.09355 16.953051,14.541512 9.53195,27.584972 -0.0667,-0.0412 -0.36959,-0.52188 -1.07017,-1.74611 4.5806,-7.59113 0.91749,-19.623688 -6.93462,-23.662259 -0.77526,-0.398737 -1.72952,-0.502351 -2.76663,-0.502351 -1.22204,0 -17.27471,-0.04757 -17.27471,-0.04757 0.52784,0.939562 1.07891,1.865762 1.62701,2.793577 l 16.37917,0.04641 c 3.92533,0 9.75467,10.280183 7.52823,17.913133 h -1.74904 c 1.36977,-3.51227 -0.27799,-10.50434 -2.04936,-12.77889 -2.94403,5.0992 -5.88203,10.18798 -8.7675,15.18576 l 11.01649,0.0846 c 2.06042,3.56549 4.12671,7.12761 6.16888,10.70361 0,0 -1.25028,0.0159 -1.86973,0 -1.77654,-3.02258 -3.52888,-6.05918 -5.28272,-9.09495 l -16.82018,-0.0847 c -0.49339,-0.002 -0.70287,-0.60362 -0.49407,-1.02539 2.44923,-4.9474 5.48108,-9.58669 8.04333,-14.47685 l -3.03172,0.0282 c -0.0385,10e-4 -0.91617,1.60771 -2.00317,3.49366 -6.10924,10.59961 -6.67192,11.61708 -6.77412,12.24951 -0.14656,0.9069 0.47588,2.37231 1.84756,2.77966 l 0.42485,0.12616 16.86027,0.005 1.73566,2.97492 c 0.95462,1.63621 1.76389,3.02493 1.76389,3.02493 h -20.82948 z"
  }), /*#__PURE__*/React.createElement("text", {
    x: -93.019432,
    y: 97.216248,
    style: {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "36.2143px",
      lineHeight: 1.25,
      fontFamily: "Poppins, sans-serif",
      fill: "#0f172a"
    }
  }, "zibit")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZibitLogoDark);
export default __webpack_public_path__ + "static/media/zibit-logo-dark.e544d93a3c6876289f9cd143b2b3f47e.svg";
export { ForwardRef as ReactComponent };